import React, { useState, useEffect } from 'react';
import './styles/App.scss';
import { QuotaList } from "./QuotaList";
import savantaLogo from './logos/Savanta_Logo_White_Pink_RGB.svg';
import claritiLogo from './logos/ClaritiLogo.png';
import { Brand } from './Brand';

function App() {
    const [brand, setBrand] = useState<Brand | undefined>(undefined);

    useEffect(() => {
        (async () => {
            setBrand(await getBrand());
        })();
    }, []);

    return (
        <div>
            {(brand) &&
                <>
                    <header className={brand === Brand.Savanta ? 'header-savanta' : 'header-clariti'}>
                        <div className="img-wrapper">
                            <img src={brand === Brand.Savanta ? savantaLogo : claritiLogo} alt="logo" />
                        </div>
                    </header>
                    <article>
                        <QuotaList brand={brand} />
                    </article>
                </>
            }
        </div>
    );
}

const getBrand = async (): Promise<Brand> => {
    const searchParams = new URLSearchParams(window.location.search);
    const result = await fetch(`api/quotas/GetBrand/${searchParams.get('id')}`);
    const brand = await result.json();

    if (result.ok) {
        switch (brand) {
            case 1:
                return Brand.Savanta;
            case 2:
                return Brand.Clariti;
        }
    }
    return Brand.Savanta;
}
export default App;